<div class="container">
    <div class="center-image">
        <img src="/assets/img/carryservice_banner.png" alt="Image" />
        <p class="top-text">{{'top.lblUnderLogo' | translate}}</p>
        <p class="top-text2">{{'top.lblUnderLogo2' | translate}}</p>
        <a class="list-hotel" (click)="moveToFacility()">
            <span>{{'top.hotelUrls' | translate}}</span>
        </a>

        <div class="action-content">
            <div class="area">
                <p class="bottom-text">{{'top.lblRequest' | translate}}</p>
                <button pButton (click)="moveToRegist()" class="custom-button p-button-warning">{{'top.btnRequest' | translate}}</button>
            </div>
            <div class="area-mobile">
                <p class="bottom-text">{{'top.lblCheck' | translate}}</p>
                <button (click)="openDialog()" class="custom-button">{{'top.btnCheck' | translate}}</button>
            </div>
            <form class="area-pc" [formGroup]="formUser">
                <p class="">{{'top.lblCheck' | translate}}</p>
                <div class="dialog-content">
                    <div class="form-item">
                        <p class="">{{'top.email' | translate}}</p>
                        <input [maxLength]="126" formControlName="email" type="email" pInputText class="p-inputtext-sm"/>
                        <div *ngIf="formUser.controls['email'].invalid && (formUser.controls['email'].dirty || submitFlag)" class="alert p-error">
                            <div *ngIf="formUser.controls['email'].errors?.['required']">
                                {{ "top.email" | translate }}{{ mes.MSG_056 }}
                            </div>
                            <div *ngIf="formUser.controls['email'].errors?.['email'] && submitFlag">
                                {{ "top.email" | translate }}{{ mes.MSG_053 }}
                            </div>
                        </div>
                    </div>
                    <div class="form-item">
                        <p class="">{{'top.tel' | translate}}</p>
                        <input [maxLength]="8" formControlName="shipId" type="tel" pInputText class="p-inputtext-sm"/>
                        <div *ngIf="formUser.controls['shipId'].invalid && (formUser.controls['shipId'].dirty || submitFlag)" class="alert p-error">
                            <div *ngIf="formUser.controls['shipId'].errors?.['required']">
                                {{ "top.tel" | translate }}{{ mes.MSG_056 }}
                            </div>
                        </div>
                    </div>
                    <button (click)="moveToConfirm()" pButton class="custom-button p-button-warning btn-pc">{{'top.btnSearch' | translate}}</button>
                </div>
            </form>
        </div>
        <div class="notifications" [innerHTML]="InfoNotifiMultiLang">
        </div>
    </div>
  </div>

  <!-- popup -->
<p-dialog [showHeader]="false" [modal]="true" [contentStyle]="{backgroundColor: '#EBE6C8', padding: '0'}" position="center" [(visible)]="dialogFlag" [style]="{width: '320px'}">
    <div class="close">
        <i class="pi pi-times" (click)="closeDialog()" style="font-size: 15px; padding: 8px;"></i>
    </div>
    <div [formGroup]="formUser">
        <div class="item-info">
            <p>{{'top.email' | translate}}</p>
            <input type="email" [maxLength]="126" formControlName="email" pInputText class="p-inputtext-sm"/>
            <div *ngIf="formUser.controls['email'].invalid && (formUser.controls['email'].dirty || submitFlag)" class="alert p-error">
                <div *ngIf="formUser.controls['email'].errors?.['required']">
                    {{ "top.email" | translate }}{{ mes.MSG_056 }}
                </div>
                <div *ngIf="formUser.controls['email'].errors?.['email'] && submitFlag">
                    {{ "top.email" | translate }}{{ mes.MSG_053 }}
                </div>
            </div>
        </div>
        <div class="item-info">
            <p>{{'top.tel' | translate}}</p>
            <input type="tel" [maxLength]="8" formControlName="shipId" pInputText class="p-inputtext-sm"/>
            <div *ngIf="formUser.controls['shipId'].invalid && (formUser.controls['shipId'].dirty || submitFlag)" class="alert p-error">
                <div *ngIf="formUser.controls['shipId'].errors?.['required']">
                    {{ "top.tel" | translate }}{{ mes.MSG_056 }}
                </div>
            </div>
        </div>
        <div class="bottom">
            <button (click)="moveToConfirm()" pButton class="p-button-warning btn-app">{{'top.btnSearch' | translate}}</button>
        </div>
    </div>
</p-dialog>